// AFTER-HOURS MARKS (UI/UX audit Phase 4). After the bell the order book is thin or empty, so the executable
// figure (BUY OPTIONS at the bid, SELL OPTIONS at the ask depth) can show a loss nobody would take - the audit
// saw "Progress to target -477.5%" and buy-back prices implying two different spots. While the market is
// closed the headline is the LAST-PRICE mark; the executable figure stays visible as the second line.
// During the session nothing changes: the executable figure is the headline.

/** {closed, value, label, executable}: what to show as the P&L headline.
 *  priceState: the backend price state (LIVE / STALE / MARKET_CLOSED / ...); executable: the bid / ask figure;
 *  mark: the last-price (LTP) figure. */
export function pnlHeadline(priceState, executable, mark, executableLabel = "to close now") {
  if (priceState === "MARKET_CLOSED" && mark != null) {
    return { closed: true, value: mark, label: "P&L at last prices", executable, executableLabel,
      title: "Market closed: marked at the last traded prices. The second line is what closing now at the visible bid / ask would realise." };
  }
  return { closed: false, value: executable, label: null, executable, executableLabel, title: undefined };
}

/** Target progress is only meaningful in session and while the trade is in profit. */
export function progressText(pct, priceState) {
  if (pct == null || priceState === "MARKET_CLOSED") return "—";
  if (pct < 0) return "in loss";
  return `${pct.toFixed(1)}%`;
}
